//import React from 'react';
import '../styles/header.css';
import { getBrand, getBrandConfig, getHomePageUrl } from "../brandResolver";

const Header = () => {
    
    const brand = getBrand();
    const cfg = getBrandConfig(brand);
    const logoPath = `/images/${cfg.logo || "logo_demo.png"}`;
    const homePage = getHomePageUrl(brand);
    
    console.log(homePage)
    return (
        <div className="header">
            <div className="header-logo">
               <a href={homePage}><img src={logoPath} alt="Logo" /></a>
            </div>
            <div className="banner">

            </div>
        </div>
    );
}

export default Header;
